import { useState } from 'react';
import type { PaginacaoBarra } from './barra-acoes-lista';

/** Opcoes do tamanho de pagina em todas as listas (S36-D3). */
export const TAMANHOS_PAGINA = [25, 50, 100, 200] as const;
/** Padrao de todas as listas (S36-D3). */
export const TAMANHO_PAGINA_PADRAO = 50;

/** Tamanho vindo da URL (ou de qualquer entrada): so as opcoes da barra; o resto cai no padrao. */
export function tamanhoPaginaValido(bruto: unknown): number | undefined {
  const n = Number(bruto);
  return (TAMANHOS_PAGINA as readonly number[]).includes(n) ? n : undefined;
}

/**
 * Paginacao LOCAL de uma lista ja carregada (sem refazer a consulta): fatia os itens e devolve a barra pronta
 * (`paginacao` do BarraDeAcoesLista). A contagem total e o numero de registros da lista, nao da pagina.
 * Nao calcula nada de negocio: so recorta o que a API devolveu. Quando a pagina some (filtro reduziu a lista),
 * cai na ultima pagina existente.
 */
export function usePaginarLista<T>(itens: readonly T[] | undefined) {
  const [tamanho, setTamanho] = useState<number>(TAMANHO_PAGINA_PADRAO);
  const [pagina, setPagina] = useState(1);
  const total = itens?.length ?? 0;
  const paginas = Math.max(1, Math.ceil(total / tamanho));
  const atual = Math.min(pagina, paginas);
  const visiveis = itens ? itens.slice((atual - 1) * tamanho, atual * tamanho) : [];
  const paginacao: PaginacaoBarra = {
    pagina: atual,
    tamanho,
    total,
    onPagina: setPagina,
    onTamanho: (t) => {
      setTamanho(t);
      setPagina(1);
    },
    tamanhos: [...TAMANHOS_PAGINA],
  };
  return { visiveis, paginacao, total };
}
